import React, { useMemo, useState } from "react";
import "./WithdrawRequest.css";
import { Grid } from "@mui/material";
import bin from "../../assets/icons/recycle-binColor.png";
import CustomDataGrid from "../components/CustomDataGrid/CustomDataGrid.tsx";
import editIcon from "../../assets/icons/downArrowWhite.png";
import approveImg from "../../assets/icons/checked.png";

const WithdrawRequest = () => {
    const [enableOptions, setEnableOptions] = useState(false);
    const [dataRows, setDataRows] = useState([
        {
            id: "fdas",
            restaurantName: "restaurant name",
            withdrawAmount: 100,
            accountHolderName: "name",
            accountNumber: "1434",
            sortCode: "dfa",
            iban: "fdaskj",
            isApproveByAdmin: "f07294b7-c94d-4d5e-a064-b1282d5b5434"
        }
    ]);

    const columns = [
        {
            field: "restaurantName",
            headerName: "Restaurant Name",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "withdrawAmount",
            headerName: "Withdraw amount",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "accountHolderName",
            headerName: "Account Holder Name",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "accountNumber",
            headerName: "Account Number",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "sortCode",
            headerName: "Sort Code",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "iban",
            headerName: "IBAN",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "isApproveByAdmin",
            headerName: "Status",
            renderCell: useMemo(
                () => (params) => {
                    return (
                        <div
                            className={`${params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5434"
                                ? "approve"
                                : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b543b" ||
                                    params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5411"
                                    ? "pending"
                                    : "reject"
                                } RoundedStatus`}
                            // onClick={() => {
                            //     handleStatusClick(params.row);
                            // }}
                            style={{ cursor: "pointer" }}
                        >
                            {params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5434" ? (
                                "Approve"
                            ) : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b543b" ? (
                                "Pending"
                            ) : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5411" ? (
                                "Resubmited"
                            ) : (
                                <span>
                                    Reject
                                    <img
                                        src={editIcon}
                                        style={{ width: "1rem", marginLeft: "10px" }}
                                    />
                                </span>
                            )}
                        </div>
                    );
                },
                []
            ),
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
    ];

    const getSelectedData = (e) => {
        console.log(e);
    };

    return (
        <div className="withdraw-container">
            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                mt={2}
                mb={2}
            >
                <Grid item>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <div
                                className={` ${enableOptions ? "" : "disable"}  roundedCorner`}
                            // onClick={() => {
                            //     approvedData(1);
                            // }}
                            >
                                <img src={approveImg} alt="" style={{ width: "1rem" }} />{" "}
                                Approve
                            </div>
                        </Grid>
                        <Grid item>
                            <div
                                className={` ${enableOptions ? "" : "disable"}  roundedCorner`}
                            // onClick={() => {
                            //     handleClickopenCancelReasonDialog();
                            // }}
                            >
                                <img src={bin} alt="" style={{ width: "1rem" }} /> Reject
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <CustomDataGrid
                columns={columns}
                dataRows={dataRows}
                getselectedData={getSelectedData}
            />
        </div>
    )
}

export default WithdrawRequest;